module.exports = __webpack_public_path__ + "static/kruthika-57cf099396ad9ec907efa7bded021eb2.jpg";